export default __webpack_public_path__ + "static/media/checkbox2--checked.5664d0ea.svg";